module.exports = __webpack_public_path__ + "img/titanium.2f17e50a.svg";